import { Avatar, Tag, Typography } from "antd";
import clsx from "clsx";
import { UserBubble, UserBubbleLinkText } from "@shared/ui";
import type { JournalPersonCardData } from "../../model/types";
import "./journal-person-card.scss";

type JournalPersonCardProps = {
  card: JournalPersonCardData;
  variant: "signatory" | "responsible";
  selected?: boolean;
  onClick?: () => void;
};

export const JournalPersonCard = ({
  card,
  variant,
  selected,
  onClick,
}: JournalPersonCardProps) => {
  // BUILDDOCS-4961: временно отключено — бейджи статусов подписания («N ожидают», «N подписано»)

  const avatar = (
    <Avatar className="journal-person-card__avatar" size={36}>
      {card.initials}
    </Avatar>
  );

  const CardComponent = onClick ? "button" : "div";

  return (
    <CardComponent
      {...(onClick ? { type: "button" as const } : {})}
      className={clsx(
        "journal-person-card",
        selected && "journal-person-card--selected",
        onClick && "journal-person-card--clickable",
      )}
      onClick={onClick}
    >
      <div className="journal-person-card__header">
        {card.userId ? (
          <UserBubble userId={card.userId} trigger="hover">
            <span
              className="journal-person-card__avatar-trigger"
              onClick={onClick ? (event) => event.stopPropagation() : undefined}
            >
              {avatar}
            </span>
          </UserBubble>
        ) : (
          avatar
        )}
        {card.userId ? (
          <UserBubbleLinkText
            userId={card.userId}
            trigger="hover"
            className="journal-person-card__name"
            onClick={onClick ? (event) => event.stopPropagation() : undefined}
          >
            {card.name}
          </UserBubbleLinkText>
        ) : (
          <Typography.Text className="journal-person-card__name">
            {card.name}
          </Typography.Text>
        )}
      </div>

      <Typography.Text className="journal-person-card__organization">
        {card.organization}
      </Typography.Text>

      <Typography.Text className="journal-person-card__subtitle">
        {card.subtitle}
      </Typography.Text>

      {variant === "responsible" && card.roleTags?.length ? (
        <div className="journal-person-card__tags">
          {card.roleTags.map((tag) => (
            <Tag key={tag} className="journal-person-card__tag">
              {tag}
            </Tag>
          ))}
        </div>
      ) : null}
    </CardComponent>
  );
};
